import * as React from 'react'
import { Link } from 'react-router-dom'

interface ThumbnailProps {
  id: string
  src: string
  height: number
  tags: string[]
}

export default ({ src, height, id, tags: [ tag ] }: ThumbnailProps) => (
  <Link to={`/${tag}/${id}`}>
    <div style={{ height }}><img src={src} /></div>
  </Link>
)



// WEBPACK FOOTER //
// ./src/components/Thumbnail/index.tsx